/**
 * Short confirmation beep for merchant-side actions (call-next / present / absent).
 * No audio files required.
 */
export function useMerchantChime() {
  const play = (type = "primary") => {
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;
      const ctx = new AudioCtx();
      const now = ctx.currentTime;
      const seq =
        type === "success"
          ? [[660, 0], [880, 0.12]]
          : type === "warn"
          ? [[440, 0], [330, 0.14]]
          : [[988, 0], [1318.5, 0.14]]; // primary = call-next
      seq.forEach(([f, t]) => {
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        osc.type = "triangle";
        osc.frequency.setValueAtTime(f, now + t);
        g.gain.setValueAtTime(0, now + t);
        g.gain.linearRampToValueAtTime(0.22, now + t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.001, now + t + 0.22);
        osc.connect(g).connect(ctx.destination);
        osc.start(now + t);
        osc.stop(now + t + 0.22);
      });
      setTimeout(() => ctx.close(), 1000);
    } catch {}
  };
  return { play };
}
